<template>
  <div class="left-aside" v-loading="loading">
    <h4>{{navTitle}}</h4>
    <ul class="product-list" v-if="hotGoods.length">
      <li class="product-item"
          @click="$tools.showGoodInBlank(item.id)"
          v-for="item in hotGoods" :key="item.id">
        <div class="product-cover">
          <el-image class="img-responsive" :src="item.photos">
            <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
          </el-image>
        </div>
        <div class="product-price">{{item.realprice | decimal}}</div>
        <div class="product-name">{{item.name}}</div>
      </li>
    </ul>
    <empty v-else>暂无热卖商品</empty>
  </div>
</template>
<script>
import {commoditylist} from '../api/xunyou';
export default {
  name: 'hotGoods',
  data() {
    return {
      loading: false,
      hotGoods: []
    };
  },
  props: ['navTitle'],
  created() {
    this.getCommodityList();
  },
  methods: {
    // 热卖商品列表查询
    getCommodityList() {
      const params = {
        pageSize: 4,
        pageNum: 1,
        cid: '',
        stype: 2,
        sortname: 'saleNum'
      };
      this.loading = true;
      commoditylist(params).then((res) => {
        this.loading = false;
        console.log('热卖商品列表：', res);
        if (res.code === 0) {
          this.hotGoods = res.rows;
        }
      }).catch((err) => {
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.left-aside {
  font-size: 14px;
  background-color: #fff;
}
.left-aside h4 {
  font-weight: bold;
  padding: 10px;
  border-bottom: 1px solid #e7e7e7;
}
.product-item {
  padding: 10px;
  cursor: pointer;
  .product-cover{
    width: 160px;
    height: 160px;
  }
  .product-price {
    margin-top: 5px;
    color: var(--main-theme-color);
    font-weight: bold;
    &:before{
      content: '￥';
      font-size: 12px;
    }
  }
  .product-name{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.left_product {
  padding: 10px;
}
.left_product li {
  margin-bottom: 30px;
}
.pro-price {
  margin: 10px 0;
  color: #e4393c;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
}
.img-responsive {
  /* width: 100%; */
  width: 160px;
  height: 160px;
}

.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}
</style>







// WEBPACK FOOTER //
// src/components/hotGoods.vue